import React, { useEffect, useRef } from 'react';
import styleCommonMd from '../../index.module.scss';
import styleMd from './styles/selector.module.scss';

const Selector = props => {
    const { items , setFunc } = props;
    const refEl = useRef(null);

    useEffect(() => {
        onClick(0);
    }, [])

    const onClick = (index) => {
        setFunc && setFunc(index);
        var items = refEl.current.querySelectorAll(`.${styleMd.item}`);
        for (let i = 0; i < items.length; i++) {
            let item = items[i], activeClass = `${styleMd['item--active']}`;
            let isActive = item.classList.contains(activeClass);

            if(i === index){
                if(!isActive)
                    item.classList.add(activeClass);
                continue;
            }
            items[i].classList.remove(activeClass);
        }
    }
    
    return (
        items && <div ref={refEl} className={styleMd.container}>
            {items.map((item,index)=> (
                <a className={[styleMd.item, styleMd.href].join(' ')} key={index} onClick={()=>{ onClick(index) }}>
                    <img className={styleCommonMd.img} src={item.src} alt={item.alt}/>
                </a>
            ))}  
        </div>
    );
};

export default Selector;